import { apiRequest, buildURL } from './commons/CommonService.Functions';

// models
import {
  PersonRelationshipCreateCommand,
  PersonRelationshipUpdateCommand,
  PersonRelationshipViewModel
} from '../models/Entities/Person/Relationship/PersonRelationshipModels';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'persons';

// Get all relationships of a person
export const GetPersonRelationships = async (
  token: string,
  personId: number
): Promise<PersonRelationshipViewModel[]> => {
  const requestUrl: string = buildURL(BaseURL, personId, 'relationships');
  return apiRequest<PersonRelationshipViewModel[]>(requestUrl, token, 'GetPersonRelationships');
};

// Get relationship by id
export const GetPersonRelationshipById = async (
  token: string,
  personRelationshipId: number
): Promise<PersonRelationshipViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'relationships', personRelationshipId);
  return apiRequest<PersonRelationshipViewModel>(requestUrl, token, 'GetPersonRelationshipById');
};

// Create relationship
export const CreatePersonRelationship = async (
  token: string,
  payload: PersonRelationshipCreateCommand
): Promise<PersonRelationshipViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'relationships');
  return apiRequest<PersonRelationshipViewModel>(requestUrl, token, 'CreatePersonRelationship', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};

// Update relationship
export const UpdatePersonRelationship = async (
  token: string,
  payload: PersonRelationshipUpdateCommand
): Promise<PersonRelationshipViewModel> => {
  const requestUrl: string = buildURL(BaseURL, 'relationships');
  return apiRequest<PersonRelationshipViewModel>(requestUrl, token, 'UpdatePersonRelationship', {
    method: 'PUT',
    body: JSON.stringify(payload)
  });
};

// Delete relationship
export const DeletePersonRelationship = async (
  token: string,
  personRelationshipId: number
): Promise<number> => {
  const requestUrl: string = buildURL(BaseURL, 'relationships', personRelationshipId);
  return apiRequest<number>(requestUrl, token, 'DeletePersonRelationship', {
    method: 'DELETE'
  });
};
